<div class="dialogue-content">
  <div class="mat-dialogue-header">
    <h4>Session Detail</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
  <mat-dialog-content class="">
    <div class="d-flex justify-content-between border-bottom pb-3">
      <div class="day-line">
        <h3> {{sessionDescription.sessionDay}} | {{sessionDescription.sessionStartDateTime | date:'MMMM'}}</h3>
      </div>
      <div class="time-line">
        <i class="fa-regular fa-clock pe-2"></i> <span>{{ sessionDescription.sessionStartDateTime | date:
            dateFormat.shortTime }} -
            {{ sessionDescription.sessionEndDateTime | date: dateFormat.shortTime }} | <span
                [innerHTML]="sessionDescription.sessionStartDateTime | ordinalDate : sessionDescription.sessionStartDateTime"></span>
        </span>
    </div>
    </div>
    <div class="class-heading">
      <h4 class="mt-3"><span class="WrapData" title="">{{sessionDescription.className}}</span></h4>
    </div>
    <div class="class-details p-2">
      <div [innerHTML]="sessionDescription.description"></div>
      <p>If you have any questions please email -<a href="mailTo:rakhee@superarilife.com"
          class="text-decoration-underline"><b>
            rakhee&#64;superarilife.com </b></a> - Always happy to help</p>
    </div>
    <div class="mt-3 text-center">
      <button class="btn btn-primary-outline previous-btn" (click)="cancel()">
        Previous
      </button>
    </div>
  </mat-dialog-content>
</div>